import { render } from "./TestCreationForm.vue?vue&type=template&id=4802c610&scoped=true"
import script from "./TestCreationForm.vue?vue&type=script&lang=js"
export * from "./TestCreationForm.vue?vue&type=script&lang=js"

import "./TestCreationForm.vue?vue&type=style&index=0&id=4802c610&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4802c610"]])

export default __exports__